import { useEffect, useState } from 'react';
import { fetchAIGenerationSessions } from '@/features/datasets/utils/aiGenerationDataset';

/** Past Generate-with-AI configurations for the "Load Previous" dropdown. */
export default function useGenerationSessions(usecaseId, open) {
    const [sessions, setSessions] = useState([]);

    useEffect(() => {
        if (!open || !usecaseId) return undefined;
        let cancelled = false;
        fetchAIGenerationSessions(usecaseId).then((rows) => {
            if (!cancelled) setSessions(rows);
        });
        return () => {
            cancelled = true;
        };
    }, [open, usecaseId]);

    return sessions;
}
